import { action } from 'satcheljs';
import { SearchTab } from '../store/TabbedSearchStore';

/**
 * Action whichs kicks off a 3S search for a given non-mail tab and query to search
 */
export const invoke3sSearchForTab = action(
    'invoke3sSearchForTab',
    (tab: SearchTab, queryString: string) => ({
        tab,
        queryString,
    })
);
